import React from "react";

import HSGCard from "../../../../Components/HSGCard/HSGCard";

import Avatar from "react-avatar";

import "../SmartClinic.css";
import "./Student.css";
import Constants from "../../../../Phi/Constants";

import moment from "moment";
import  history  from '../../../../history';

const SMALL_SWITCH = 995;
class StudentCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showVaccinations: false,
            genderMap : {
                M: "MALE",
                F: "FEMALE",
                O: "OTHER"
            }
        };
    }

    componentWillMount() {
        if (this.props.studentProfile && this.props.studentProfile.json_value) {
            this.setState({
                vaccineList: this.parseList(this.props.vaccines.data, this.props.studentProfile.json_value.vaccination),
            });
        }
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        if (nextProps.studentProfile && nextProps.studentProfile.json_value) {
            this.setState({
                vaccineList: this.parseList(nextProps.vaccines.data, nextProps.studentProfile.json_value.vaccination),
            });
        }
    }

    getValueInputDivision = (className, label, input, defaultInput) =>
        input || defaultInput ? (
            <div className={className}>
                <label className="hsg-sv-label">{label}</label>
                <label className="hsg-sv-input">{`${input ? input : defaultInput}`}</label>
            </div>
        ) : null;

    getValueDivision = (className, label, input) => (
        <div className={className}>
            <text>{label}</text>
            <text>{`${input || "NA"}`}</text>
        </div>
    );

    formatCommaStrings = (string) => (string ? string.trim().slice(0, -1).toUpperCase() : null);

    // _renderStudentBasicInfo = (student) => {

    //     let studentClass = student.class ? (student.class + (student.section ? ' | ' + student.section : '')) : 'NA'

    //     return (
    //         <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">
    //             <div className="col-md-12 col-sm-12 col-xs-12">
    //                 <label className = "hsg-sv-label">{'Basic Info'}</label>
    //                 {/* <label className = "hsg-sv-label right" onClick = {() => this.props.openStudentProfile(student.student_id)}>{'View Profile'}</label> */}
    //             </div>
    //             <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">
    //                 {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Class: ', studentClass, 'NA')}
    //                 {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'HSG Id: ', student.uuid, 'NA')}
    //                 {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Gender: ', student.gender, 'NA')}
    //                 {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'DOB: ', student.dob, 'NA')}
    //                 {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'Admission Number: ', student.admission_number, 'NA')}
    //             </div>
    //         </div>
    //     )
    // }

    parseList(list, vaccination) {
        const result = [];

        let selected = null;

        if (vaccination && vaccination.length > 0) {
            selected = vaccination;
        }

        list.forEach((item, pos) => {
            const vac = {
                id: item.id,
                name: item.name,
                type: item.type,
                dose: JSON.parse(item.custom_json),
            };

            let saved = null;
            if (selected !== null) {
                const obj = selected.find((data) => data.id === vac.id);
                if (Boolean(obj)) saved = obj.dose;
            }

            vac.dose.forEach((dose, pos1) => {
                dose.yearGiven = 1;
                dose.monthGiven = 0;

                if (saved !== null) {
                    let status = false;
                    for (let i = 0; i < saved.length; i++) {
                        if (saved[i].index === pos1) {
                            status = true;
                            dose.yearGiven = saved[i].yearGiven;
                            dose.monthGiven = saved[i].monthGiven;

                            break;
                        }
                    }

                    dose.status = status;
                } else {
                    dose.status = false;
                }
            });

            if (vac.dose.length > 1) {
                vac.showAll = false;
            }

            result.push(vac);
        });

        return result;
    }

    _renderBMIInfoMSG = (student) => {
        let bmiClass = this.zScoreClassification(student.range);

        return student.at_five && student.at_eighty_five && student.bmi && bmiClass !== "Normal" ? (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 student-bmi-info-background">
                <p className="student-bmi-info-range">
                    {`At height ${student.height} cms healthy BMI should be between ${student.five_perc} and ${
                        student.eighty_five_perc
                    }. 
                        To get into the healthy BMI range need to ${
                            student.bmi > student.at_eighty_five ? "lose" : "gain"
                        } 
                        ${
                            // `Healthy BMI range should be between ${student.at_five} to ${student.at_eighty_five}. Need to ${
                            //     student.bmi > student.at_eighty_five ? "lose" : "gain" ''
                            ""
                        }
                    ${
                        student.bmi > student.at_eighty_five ? student.at_eighty_five : student.at_five
                        // student.bmi > student.at_five
                        //     ? student.at_eighty_five > 0
                        //         ? student.at_eighty_five
                        //         : -student.at_eighty_five
                        //     : student.at_five > 0
                        //     ? student.at_five
                        //     : -student.at_five
                    } KG(s)`}
                </p>
                <p className="student-bmi-info-msg">
                    {`${this.calculateBmi(student.height, student.weight)} (${bmiClass})`}
                </p>
            </div>
        ) : bmiClass === "Normal" ? (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 student-bmi-info-background-normal">
                <p className="student-bmi-info-msg">BMI falls into healthy BMI range</p>
            </div>
        ) : (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 student-bmi-info-background">
                <p className="student-bmi-info-msg">Data not available!</p>
            </div>
        );
    };

    _renderStudentBasicInfo = (student) => {
        let studentClass = student.class ? student.class + (student.section ? " - " + student.section : "") : "NA";

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                {this.props.dim.width > SMALL_SWITCH ? (
                    <div className="col-lg-2 col-md-2 col-sm-3 col-xs-3 padding-10 student-avatar-container">
                        <Avatar name={student.name} src={student.json_value.profile_picture} round="50px" />
                    </div>
                ) : null}
                <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 no-padding">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12 no-padding student-card-name">
                            {student.name}
                        </div>
                        <div
                            className="col-lg-5 col-md-5 col-sm-12 col-xs-12 no-padding"
                            style={{ textAlign: "right" }}
                        >
                            {Constants.userPermissionMap[this.props.roleType] &&
                                Constants.userPermissionMap[this.props.roleType].includes(
                                    Constants.userPermissionId.ADD
                                ) && (
                                    <label
                                        className="hsg-sv-label"
                                        style={{ color: "#a0c2ff", cursor: "pointer", padding: 10 }}
                                        onClick={() => this.props.toggleEpisodeModal(true)}
                                    >
                                        {"Add Episode"}
                                    </label>
                                )}
                            <label
                                className="hsg-sv-label"
                                style={{ color: "#a0c2ff", cursor: "pointer", padding: 10 }}
                                onClick={() => this.props.closeStudentProfile(false)}
                            >
                                {"Close"}
                            </label>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{ paddingTop: 10 }}>
                            {this.getValueDivision("col-lg-6 col-md-6 col-sm-6 col-xs-6 row", "Class: ", studentClass)}
                            {/* {this.getValueDivision(
                                "col-lg-6 col-md-6 col-sm-6 col-xs-12 row padding-top-3",
                                "HSG Id: ",
                                student.uuid
                            )} */}
                            {this.getValueDivision(
                                "col-lg-6 col-md-6 col-sm-6 col-xs-12 row padding-top-3",
                                "Gender: ",
                                student.gender ? (this.state.genderMap[student.gender.toUpperCase()]) : ''
                            )}
                            {this.getValueDivision(
                                "col-lg-6 col-md-6 col-sm-6 col-xs-12 row padding-top-3",
                                "Admission Num.: ",
                                student.admission_number
                            )}
                            {this.getValueDivision(
                                "col-lg-6 col-md-6 col-sm-6 col-xs-12 row padding-top-3",
                                "DOB: ",
                                moment(student.dob).format(Constants.defaultDateFormat)
                            )}
                            {/* {this.getValueDivision("col-lg-6 col-md-6 col-sm-6 col-xs-6 row padding-top-3", "Blood Group: ", student.json_value.healthHistory && student.json_value.healthHistory.bloodGroup)} */}
                            {/* {this.props.roleType !== 5 && Boolean(student.episodes) && Boolean(student.episodes[0].nurse_name) && this.getValueDivision(
                                "col-lg-6 col-md-6 col-sm-6 col-xs-12 row padding-top-3",
                                "Nurse Name: ",
                                student.episodes[0].nurse_name
                            )} */}
                            {this.props.roleType !== 5 && Boolean(student.episodes) && Boolean(student.episodes[0].med_spo_2)   && this.getValueDivision(
                                "col-lg-6 col-md-6 col-sm-6 col-xs-12 row padding-top-3",
                                "SPO2: ",
                                student.episodes[0].med_spo_2
                            )}
                            { history.location.pathname === 'infirmary' &&  this.props.roleType !== 5 && Boolean(student.episodes) && Boolean(student.episodes[0].med_in_time)  && this.getValueDivision(
                                "col-lg-6 col-md-6 col-sm-6 col-xs-12 row padding-top-3",
                                "Time In: ",
                                student.episodes[0].med_in_time
                            )}
                            { history.location.pathname === 'infirmary' &&  this.props.roleType !== 5 && Boolean(student.episodes) && Boolean(student.episodes[0].med_out_time) && this.getValueDivision(
                                "col-lg-6 col-md-6 col-sm-6 col-xs-12 row padding-top-3",
                                "Time out: ",
                                student.episodes[0].med_out_time
                            )}
                        </div>
                        <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">{this._renderBMIInfoMSG(student)}</div>
                    </div>
                </div>
            </div>
            // <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">
            //     <div className="col-md-12 col-sm-12 col-xs-12">
            //         <label className = "hsg-sv-label">{'Basic Info'}</label>
            //         {/* <label className = "hsg-sv-label right" onClick = {() => this.props.openStudentProfile(student.student_id)}>{'View Profile'}</label> */}
            //     </div>
            //     <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">
            //         {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Class: ', studentClass, 'NA')}
            //         {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'HSG Id: ', student.uuid, 'NA')}
            //         {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Gender: ', student.gender, 'NA')}
            //         {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'DOB: ', student.dob, 'NA')}
            //         {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'Admission Number: ', student.admission_number, 'NA')}
            //     </div>
            // </div>
        );
    };

    _renderStudentParentInfo = (parent) => {
        let parentName = parent && parent.parent_name ? parent.parent_name.trim().toUpperCase() : "NA";
        let parentArray;

        try {
            parentArray = JSON.parse(parent.json_value.parent);
        } catch (e) {
            parentArray = null;
        }

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <label className="hsg-sv-label">{"Parent Info"}</label>
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">
                    {this._renderParentInfo(parent, 999)}
                    {parentArray && parentArray.map((parent, index) => this._renderParentInfo(parent, index))}
                </div>
            </div>
        );
    };

    _renderParentInfo = (parent, index) => {
        let parentName = parent && parent.parent_name ? parent.parent_name.trim().toUpperCase() : "NA";

        return (
            <div key={index} className="col-md-12 col-sm-12 col-xs-12">
                {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", "Name: ", parentName, "NA")}
                {this.getValueInputDivision("row col-md-4 col-sm-12 col-xs-12", "Email: ", parent.user_email, "NA")}
                {this.getValueInputDivision(
                    "row col-md-2 col-sm-12 col-xs-12",
                    "Contact: ",
                    parent.user_phone_number,
                    "NA"
                )}
                {this.getValueInputDivision(
                    "row col-md-2 col-sm-12 col-xs-12",
                    "Other: ",
                    parent.emergencyContact,
                    null
                )}
            </div>
        );
    };

    // _renderStudentMedicalInfo = (medicalInfo) => {

    //     let ailment = ''
    //     ailment = Boolean(medicalInfo.previousIllnessRecord) ? medicalInfo.previousIllnessRecord : ailment
    //     ailment = Boolean(ailment) && Boolean(medicalInfo.ailment) ? ailment + ', ' + medicalInfo.ailment :  Boolean(ailment) ? ailment : Boolean(medicalInfo.ailment) ? medicalInfo.ailment : null

    //     return (
    //         <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">
    //             <div className="col-md-12 col-sm-12 col-xs-12">
    //                 <label className = "hsg-sv-label">{'Medical Info'}</label>
    //             </div>
    //             <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">

    //                 {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Food Allergies: ', medicalInfo.foodAllergies, null)}
    //                 {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Medicine Allergies: ', medicalInfo.medicineAllergies, null)}
    //                 {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Others: ', medicalInfo.otherAllergies && medicalInfo.otherAllergies.toUpperCase() || null , null)}
    //                 {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Any Previous Illness: ', ailment && ailment.toUpperCase() || null, null)}
    //                 {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Blood Group: ', medicalInfo.bloodGroup, null)}
    //                 {this.getValueInputDivision("row col-md-10 col-sm-12 col-xs-12", 'Remarks: ', medicalInfo.remarks, null)}

    //             </div>
    //         </div>
    //     )
    // }

    trimFloat(value) {
        return Number(parseFloat(Math.round(parseFloat(value * 100).toFixed(3)) / 100).toFixed(2));
    }

    calculateBmi(height, weight) {
        height = parseFloat(height) / 100;
        weight = parseFloat(weight);

        const bmi = weight / (height * height);

        return this.trimFloat(bmi);
    }

    zScoreClassification(range) {
        if (range === "normal") {
            return "Normal";
        } else if (range === "overweight") {
            return "Over Weight";
        } else if (range === "underweight") {
            return "Under Weight";
        } else if (range === "obese") {
            return "Obese";
        } else null;
    }

    getMedicationList = (healthHistory) =>
        healthHistory.medicationList && healthHistory.medicationList.length ? (
            <div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row" style={{ fontWeight: "bold" }}>
                    Current Medication
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    {healthHistory.medicationList.map((element, index) => (
                        <div key={index}>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Condition: ",
                                    element.condition
                                )}
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Ailment: ",
                                    element.type
                                )}
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Severity: ",
                                    element.severity
                                )}
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Medication: ",
                                    element.medication
                                )}
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Started On: ",
                                    element.startedOn
                                )}
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Ended On: ",
                                    element.endedOn
                                )}
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <hr style={{ margin: 3 }} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        ) : null;

    getHistoryList = (healthHistory) =>
        healthHistory.historyList && healthHistory.historyList.length ? (
            <div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row" style={{ fontWeight: "bold" }}>
                    History
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    {healthHistory.historyList.map((element, index) => (
                        <div key={index}>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={index}>
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Condition: ",
                                    element.condition
                                )}
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Ailment: ",
                                    element.type
                                )}
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Severity: ",
                                    element.severity
                                )}
                                {this.getValueDivision(
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                    "Medication: ",
                                    element.medication
                                )}
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <hr style={{ margin: 3 }} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        ) : null;

    vaccinationRow = (vaccinations, head, id) => {
        let vaccination = [];

        vaccinations && vaccinations.length
            ? vaccinations.map((element, index) =>
                  element.type === head
                      ? element.dose.map((item, pos) => {
                            item.status
                                ? vaccination.push(
                                      <div
                                          className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                          key={`${id}-${index}-${pos}`}
                                      >
                                          {this.getValueDivision(
                                              "col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding",
                                              "Type: ",
                                              element.name
                                          )}
                                          {this.getValueDivision(
                                              "col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding",
                                              "Age Recommended: ",
                                              item.ageRecommended
                                          )}
                                          {this.getValueDivision(
                                              "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                              "Catchup Period: ",
                                              item.catchUpPeriod
                                          )}
                                          {this.getValueDivision(
                                              "col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding",
                                              "Age: ",
                                              `${item.yearGiven ? `${item.yearGiven} year` : ``} ${
                                                  item.monthGiven ? `${item.monthGiven} month` : ``
                                              }`
                                          )}
                                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                              <hr style={{ margin: 3 }} />
                                          </div>
                                      </div>
                                  )
                                : null;
                        })
                      : null
              )
            : null;
        return vaccination.length ? vaccination : null;
    };

    getVaccinationList = () => {
        let generalVaccination = this.vaccinationRow(this.state.vaccineList, "General Vaccination", "vac");
        let boosterDose = this.vaccinationRow(this.state.vaccineList, "Booster Dose", "bd");
        let additionalVaccinations = this.vaccinationRow(this.state.vaccineList, "Additional Vaccination", "av");

        return (
            <div>
                {generalVaccination ? (
                    <div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row" style={{ fontWeight: "bold" }}>
                            General Vaccinations
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">{generalVaccination}</div>
                    </div>
                ) : null}

                {boosterDose ? (
                    <div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row" style={{ fontWeight: "bold" }}>
                            Booster Dose
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">{boosterDose}</div>
                    </div>
                ) : null}

                {additionalVaccinations ? (
                    <div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row" style={{ fontWeight: "bold" }}>
                            Additional Vaccinations
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">{additionalVaccinations}</div>
                    </div>
                ) : null}
            </div>
        );
    };

    _renderStudentMedicalInfo = (studentInfo, medicalInfo) => {
        let healthHistory = medicalInfo.healthHistory || {};
        let vaccination = medicalInfo.vaccination || {};

        // let ailment = ''
        // ailment = Boolean(medicalInfo.previousIllnessRecord) ? medicalInfo.previousIllnessRecord : ailment
        // ailment = Boolean(ailment) && Boolean(medicalInfo.ailment) ? ailment + ', ' + medicalInfo.ailment :  Boolean(ailment) ? ailment : Boolean(medicalInfo.ailment) ? medicalInfo.ailment : null

        return (
            <div
                className="col-lg-12 col-md-12 col-sm-12 col-xs-12 student-medical-info-background"
                style={{ marginTop: 10 }}
            >
                {this.getValueDivision(
                    "col-lg-2 col-md-2 col-sm-4 col-xs-6 row padding-top-3",
                    "Blood Group: ",
                    healthHistory.bloodGroup === "Select Blood Group" ? null : healthHistory.bloodGroup
                )}
                {this.getValueDivision(
                    "col-lg-2 col-md-2 col-sm-4 col-xs-6 row padding-top-3",
                    "Height: ",
                    studentInfo.height
                )}
                {this.getValueDivision(
                    "col-lg-2 col-md-2 col-sm-4 col-xs-6 row padding-top-3",
                    "Weight: ",
                    studentInfo.weight
                )}
                {this.getValueDivision(
                    "col-lg-2 col-md-2 col-sm-4 col-xs-6 row padding-top-3",
                    "BMI: ",
                    this.calculateBmi(studentInfo.height, studentInfo.weight)
                )}
                {this.getValueDivision(
                    "col-lg-2 col-md-2 col-sm-4 col-xs-6 row padding-top-3",
                    "DOA: ",
                    studentInfo.recent_time ? moment(studentInfo.recent_time).format(Constants.defaultDateFormat) : null
                )}
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row padding-top-3">
                    {this.state.showVaccinations ? this.getMedicationList(healthHistory) : null}
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
                    {this.state.showVaccinations ? this.getHistoryList(healthHistory) : null}
                </div>

                {medicalInfo.eligibilitySports && this.state.showVaccinations
                    ? this.getValueDivision(
                          "col-lg-12 col-md-12 col-sm-12 col-xs-12 row padding-top-3",
                          "",
                          medicalInfo.eligibilitySports
                      )
                    : null}

                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
                    {this.state.showVaccinations ? this.getVaccinationList() : null}
                    <div
                        className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                        style={{ cursor: "pointer", textAlign: "right" }}
                        onClick={() => this.setState({ showVaccinations: !this.state.showVaccinations })}
                    >
                        {this.state.showVaccinations ? "Close" : "Expand"}
                    </div>
                </div>

                {/* {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)}
                {this.getValueDivision("col-lg-2 col-md-2 col-sm-2 col-xs-2 row padding-top-3", "HSG Id: ", medicalInfo.foodAllergies)} */}
                {/*
                {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Food Allergies: ', medicalInfo.foodAllergies, null)}
                {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Medicine Allergies: ', medicalInfo.medicineAllergies, null)}
                {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Others: ', medicalInfo.otherAllergies && medicalInfo.otherAllergies.toUpperCase() || null , null)}
                {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Any Previous Illness: ', ailment && ailment.toUpperCase() || null, null)}
                {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Blood Group: ', medicalInfo.bloodGroup, null)}
                {this.getValueInputDivision("row col-md-10 col-sm-12 col-xs-12", 'Remarks: ', medicalInfo.remarks, null)} */}
            </div>
        );
    };

    render() {
        let { episodeList, studentProfile } = this.props;

        studentProfile = Object.assign({}, studentProfile, {
            bmi: this.calculateBmi(studentProfile.height, studentProfile.weight),
        });

        return (
            // <HSGCard
            //     headingLeft = {studentProfile.name}
            //     headingRight = {
            //         <div>
            //             <label className = "hsg-sv-label right" style = {{color: '#a0c2ff', cursor: "pointer"}} onClick = {() => this.props.closeStudentProfile()}>{'Close Profile'}</label>
            //             <label className = "hsg-sv-label right" style = {{color: '#a0c2ff', cursor: "pointer", paddingRight: 10}} onClick = {() => this.props.toggleEpisodeModal(true)}>{'Add Episode'}</label>
            //         </div>
            //     }
            //     >

            //     <div style ={{marginBottom: 10}}></div>

            //     <div className="hsg-card-details row"> {this._renderStudentBasicInfo(studentProfile)} </div>
            //     <div className="hsg-card-details row"> {this._renderStudentParentInfo(studentProfile)} </div>
            //     <div className="hsg-card-details row"> {this._renderStudentMedicalInfo(studentProfile.json_value)} </div>

            // </HSGCard>

            <HSGCard hideHeader>
                <div className="show-grid row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        {this._renderStudentBasicInfo(studentProfile)}
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        {this._renderStudentMedicalInfo(studentProfile, studentProfile.json_value)}
                    </div>
                </div>
            </HSGCard>
        );
    }
}

export default StudentCard;



// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainerV2/Component/Student/StudentCard.js